<template>
  <organism-backup-settings
    v-if="filterData"
    :fields="tableAutoBackupConfigFields"
    :items="autoBackupConfigList"
    :filterList="filterData"
    @onUpdateFilterData="onUpdateFilterData"
    @onUpdateCurrentPage="onUpdateCurrentPage"
    @onSetDefaultFilterData="onSetDefaultFilterData"
    @clickRow="clickRow"
    @onRequestDeleteAutoBackupConfig="onRequestDeleteAutoBackupConfig"
  ></organism-backup-settings>
</template>

<script>
import OrganismBackupSettings from "@/components/organisms/networkConfigurationManagement/OrganismBackupSettings.vue"

import {
  getAutoBackupConfigList,
  deleteAutoBackupConfig,
} from "@/api/api-module4"
import { mapActions, mapGetters } from "vuex"
import mixins from "@/mixins"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

export default {
  name: "BackupSettings",
  components: { OrganismBackupSettings },
  mixins: [mixins, mixinsObjectHelper],
  data() {
    return {
      tableAutoBackupConfigFields: [
        {
          key: "autoBackupConfigName",
          label: "BACKUP TEMPLATE NAME",
        },
        {
          key: "autoBackupConfigDescription",
          label: "DESCRIPTION",
        },
        {
          key: "deleteIcon",
          label: "",
          // thClass: "w-25px",
          // tdClass: "w-25px",
        },
      ],

      autoBackupConfigList: [],

      filterData: null,
    }
  },
  computed: {
    ...mapGetters("appFilter", ["getNCMBackupSettingsFilter"]),
  },
  async mounted() {
    await this.fetchDataFromApi()
  },
  methods: {
    ...mapActions("appFilter", ["setNCMBackupSettingsFilter"]),

    cloneFilterDataFromVuex() {
      const filterDataFromVuex = this.getNCMBackupSettingsFilter
      this.filterData = this.deepCopyObject(filterDataFromVuex)
    },

    fetchDataFromApi() {
      this.getAutoBackupConfigListFromApi()
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    clickRow(autoBackupConfigId) {
      const path = `/network-configuration/backup-settings/${autoBackupConfigId}`
      this.navigateTo(path)
    },

    onRequestDeleteAutoBackupConfig(autoBackupConfigId) {
      this.sendRequestDeleteAutoBackupConfigToApi(autoBackupConfigId)
    },

    async getAutoBackupConfigListFromApi() {
      this.showLoading(true)
      this.cloneFilterDataFromVuex()
      const filterData = this.filterDecoration()
      await getAutoBackupConfigList(filterData)
        .then((response) => {
          if (response) {
            this.filterData.total = response.totalCount
            const updatedFilter = {
              ...this.getNCMBackupSettingsFilter,
              total: response.totalCount,
            }
            this.setNCMBackupSettingsFilter(updatedFilter)
            this.autoBackupConfigList = response.data
          }
        })
        .finally(() => this.showLoading(false))
    },

    filterDecoration() {
      const filter = {
        PageSize: 10,
        PageNumber: this.filterData.currentPage,
        Search: this.filterData?.nameOrDescription || undefined,
      }
      return filter
    },

    // click filter
    onUpdateFilterData(filter) {
      filter.currentPage = 1
      this.setNCMBackupSettingsFilter(filter)
      this.getAutoBackupConfigListFromApi()
    },

    onUpdateCurrentPage(filter) {
      const updatedFilter = {
        ...this.getNCMBackupSettingsFilter,
        currentPage: filter.currentPage,
      }
      this.setNCMBackupSettingsFilter(updatedFilter)
      this.getAutoBackupConfigListFromApi()
    },

    onSetDefaultFilterData() {
      const defaultFilter = {
        nameOrDescription: "",
        currentPage: 1,
        total: 0,
      }
      this.setNCMBackupSettingsFilter(defaultFilter)
      this.getAutoBackupConfigListFromApi()
    },

    async sendRequestDeleteAutoBackupConfigToApi(autoBackupConfigId) {
      this.showLoading(true)
      await deleteAutoBackupConfig(autoBackupConfigId)
        .then((response) => {
          if (response) {
            this.toastSuccess("Deleted Successfully")
            this.$router.go()
          } else {
            this.toastError("Delete Failed")
          }
        })
        .catch((error) => {
          this.toastError(error.response.data.ErrorMessage)
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
